// src/pages/admin/Settings.jsx (Update the security tab section)
import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { FiUser, FiGlobe, FiShield, FiSave } from 'react-icons/fi';
import ProfileSettings from '../../components/admin/ProfileSettings';
import SecuritySettings from '../../components/admin/SecuritySettings';

function Settings() {
  const { actualTheme, setTheme } = useTheme();
  const [activeTab, setActiveTab] = useState('profile');
  const [preferences, setPreferences] = useState({
    theme: 'dark',
    emailNotifications: true,
    marketingEmails: false,
    twoFactorAuth: false,
  });
  const [loading, setLoading] = useState(false);

  const handleSavePreferences = async () => {
    setLoading(true);
    // Add your preferences save logic here
    setTimeout(() => {
      setLoading(false);
      alert('Preferences saved!');
    }, 1000);
  };

  const tabs = [
    { id: 'profile', label: 'Profile', icon: FiUser },
    { id: 'preferences', label: 'Preferences', icon: FiGlobe },
    { id: 'security', label: 'Security', icon: FiShield },
  ];

  return (
    <div className="max-w-6xl mx-auto space-y-6 pb-8">
      <div>
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text)' }}>
          Settings
        </h1>
        <p className="text-sm mt-1" style={{ color: 'var(--muted)' }}>
          Manage your account settings and preferences
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-6">
        <div className="lg:w-64 space-y-1">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-xl transition-all ${
                activeTab === tab.id
                  ? 'bg-black/10 dark:bg-white/10'
                  : 'hover:bg-black/5 dark:hover:bg-white/5'
              }`}
              style={{
                color: activeTab === tab.id ? 'var(--text)' : 'var(--muted)',
              }}
            >
              <tab.icon className="w-4 h-4" />
              <span className="text-sm font-medium">{tab.label}</span>
            </button>
          ))}
        </div>

        {activeTab === 'profile' && <ProfileSettings />}

        {activeTab === 'security' && <SecuritySettings />}

        {activeTab === 'preferences' && (
          <div className="flex-1">
            <div
              className="rounded-2xl p-6 border"
              style={{
                backgroundColor: 'var(--bg)',
                borderColor: 'var(--border)',
              }}
            >
              <h2
                className="text-lg font-semibold mb-4"
                style={{ color: 'var(--text)' }}
              >
                App Preferences
              </h2>
              <div className="space-y-4">
                <div>
                  <label
                    className="block text-sm font-medium mb-2"
                    style={{ color: 'var(--text)' }}
                  >
                    Theme
                  </label>
                  <div className="flex gap-3">
                    {['light', 'dark', 'system'].map(theme => (
                      <button
                        key={theme}
                        onClick={() =>
                          setPreferences({ ...preferences, theme })
                        }
                        className={`px-4 py-2 rounded-xl capitalize transition-all ${
                          preferences.theme === theme
                            ? 'bg-black/10 dark:bg-white/10'
                            : 'border hover:bg-black/5 dark:hover:bg-white/5'
                        }`}
                        style={{
                          borderColor: 'var(--border)',
                          color: 'var(--text)',
                        }}
                      >
                        {theme}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-medium" style={{ color: 'var(--text)' }}>
                      Email Notifications
                    </p>
                    <p className="text-sm" style={{ color: 'var(--muted)' }}>
                      Receive email updates about your account
                    </p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={preferences.emailNotifications}
                      onChange={e =>
                        setPreferences({
                          ...preferences,
                          emailNotifications: e.target.checked,
                        })
                      }
                      className="sr-only peer"
                    />
                    <div
                      className="w-11 h-6 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all"
                      style={{
                        backgroundColor: preferences.emailNotifications
                          ? '#000'
                          : '#ccc',
                      }}
                    ></div>
                  </label>
                </div>

                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-medium" style={{ color: 'var(--text)' }}>
                      Marketing Emails
                    </p>
                    <p className="text-sm" style={{ color: 'var(--muted)' }}>
                      Receive promotional offers and updates
                    </p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={preferences.marketingEmails}
                      onChange={e =>
                        setPreferences({
                          ...preferences,
                          marketingEmails: e.target.checked,
                        })
                      }
                      className="sr-only peer"
                    />
                    <div
                      className="w-11 h-6 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all"
                      style={{
                        backgroundColor: preferences.marketingEmails
                          ? '#000'
                          : '#ccc',
                      }}
                    ></div>
                  </label>
                </div>

                <button
                  onClick={handleSavePreferences}
                  disabled={loading}
                  className="flex items-center gap-2 px-5 py-2 rounded-xl transition-all hover:opacity-80 disabled:opacity-50"
                  style={{ backgroundColor: 'var(--text)', color: 'var(--bg)' }}
                >
                  <FiSave className="w-4 h-4" />
                  {loading ? 'Saving...' : 'Save Preferences'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Settings;
